export default __webpack_public_path__ + "static/media/img3.9fa3b8ad.jpg";